<template>
    <el-main class="pageLayoutBody">
        <div class="pageForm" v-loading="isRequestLoading">
            <div class="pageFormTitle">创建项目</div>

            <el-form ref="form" :model="form" :rules="rules" label-width="102px" size="small">
                <div class="detailModule">
                    <el-form-item label="项目名称：" prop="name">
                        <el-input v-model="form.name" placeholder="请输入个人姓名或者企业名称"></el-input>
                    </el-form-item>

                    <el-form-item label="项目类型：" prop="type">
                        <el-select v-model="form.type" placeholder="请选择项目类型" size="small">
                            <el-option label="企业" value="企业"></el-option>
                            <el-option label="个人" value="个人"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="证件信息：" prop="card">
                        <el-input v-model="form.card" placeholder="请输入身份证或者组织机构代码" :maxlength="18"></el-input>
                    </el-form-item>

                    <el-form-item label="联系方式：" prop="tel">
                        <el-input v-model="form.tel" placeholder="请输入联系方式（例如：18888888888、02488888888）" :maxlength="11"></el-input>
                    </el-form-item>

                    <el-form-item label="业务类型：" prop="pro_type">
                        <el-select v-model="form.pro_type" placeholder="请选择业务类型" size="small">
                            <el-option v-for="(item, i) in typeList" :key="i" :label="item.type" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="借款金额：" prop="price">
                        <el-input v-model="form.price" placeholder="请输入借款金额(万元)"></el-input>
                    </el-form-item>

                    <el-form-item label="借款期限：" prop="time">
                        <el-input v-model="form.time" placeholder="请输入借款期限(月)"></el-input>
                    </el-form-item>

                    <el-form-item label="备注说明：" prop="desc">
                        <el-input v-model="form.desc" type="textarea" placeholder="请填写备注说明，没有可不填写"></el-input>
                    </el-form-item>

                    <el-form-item label="所需材料：" prop="finInsCode">
                        <el-upload
                                class="upload-demo"
                                :action="uploadURL"
                                name="file"
                                :headers="headers"
                                :file-list="fileList"
                                :multiple="true"
                                :limit="1"
                                :on-success="uploadSuccess"
                                :before-upload="beforeUpload"
                                :before-remove="beforeRemove">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip" style="color: #303133">具体所需提交的材料，请联络与您对接的渠道经理</div>
                            <div slot="tip" class="el-upload__tip">注：请按要求准备好相关资料后打包上传</div>
                        </el-upload>
                    </el-form-item>
                </div>

                <el-form-item style="padding-left: 16px">
                    <el-button type="primary" class="formBtn" :loading="isSubmitLoading" @click="submitForm('form', '1', '1')">保存</el-button>
                    <el-button type="success" class="formBtn" :loading="isSubmitLoading" @click="submitForm('form', '2', '1')">提交</el-button>
                    <el-button class="formBtn" @click="$router.go(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-main>
</template>

<script>
  import {getPartnerIndexInfo, postPartnerIndexEdit} from "../../../api/partner";
  import {getBusinessTypeAll} from "../../../api/business";

  export default {
    name: "partnerListEdit",
    data () {
      return {
        form: {
          name: '',
          type: '',
          pro_type: '',
          card: '',
          tel: '',
          price: '',
          time: '',
          desc: '',
          file_id: '',
          id: this.$route.query.id,
          is_push: '',
          status: ''
        },
        rules: {
          name: [
            {required: true, message: '请输入个人姓名或者企业名称', trigger: 'blur'}
          ],
          type: [
            {required: true, message: '请选择项目类型', trigger: 'change'}
          ],
          pro_type: [
            {required: true, message: '请选择业务类型', trigger: 'change'}
          ],
          card: [
            {required: true, message: '请输入身份证或者组织机构代码', trigger: 'blur'}
          ],
          tel: [
            {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],
          price: [
            {required: true, message: '请输入借款金额', trigger: 'blur'}
          ],
          time: [
            {required: true, message: '请输入借款期限', trigger: 'blur'}
          ],
        },
        isSubmitLoading: false,
        uploadURL: window.config.uploadURL,
        imageURL: window.config.imageURL,
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('access_token')
        },
        fileList: [],
        typeList: []
      }
    },
    created() {
      this.getInfo()
      this.getTypeList()
    },
    methods: {
      getInfo () {
        this.isRequestLoading = true
        getPartnerIndexInfo({
          id: this.$route.query.id
        }).then(res => {
          this.isRequestLoading = false
          if (res.code === 200) {
            this.form.name = res.data.name
            this.form.type = res.data.type
            this.form.pro_type = Number(res.data.pro_type)
            this.form.card = res.data.card
            this.form.tel = res.data.tel
            this.form.price = res.data.price
            this.form.time = res.data.time
            this.form.desc = res.data.desc
            if (res.data.file_id) {
              this.form.file_id = res.data.file_id
              this.fileList.push({
                name: res.data.file_info
              })
            }
          }
        }).catch(() => {
          this.isRequestLoading = false
        })
      },
      getTypeList () {
        getBusinessTypeAll().then(res => {
          if (res.code === 200) {
            this.typeList = res.data
          }
        })
      },
      beforeUpload (file) {
        if (file.name.split('.').reverse()[0] !== 'rar' && file.name.split('.').reverse()[0] !== 'zip') {
          this.$message({
            message: '请按要求准备好相关资料后打包上传',
            type: 'warning',
            showClose: true,
          });
          return false
        }
      },
      beforeRemove () {
        this.form.file_id = ''
      },
      uploadSuccess (res) {
        this.form.file_id = res.data.id
      },
      submitForm (formName, is_push, status) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (is_push === '2') {
              if (this.form.file_id === '') {
                this.$message({
                  message: '提交请按要求准备好相关资料后打包上传',
                  type: 'warning',
                  showClose: true,
                });
                return false
              }
            }
            this.form.is_push = is_push
            this.form.status = status
            this.isSubmitLoading = true
            postPartnerIndexEdit(this.form).then(res => {
              this.isSubmitLoading = false
              if (res.code === 200) {
                this.$message({
                  message: '项目编辑成功',
                  type: 'success',
                  showClose: true,
                });
                this.$router.go(-1)
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
          }
        })
      }
    },
    components: {
    }
  }
</script>
